import { Component, Input } from '@angular/core';

@Component({
    selector: 'analytics-base-chart',
    templateUrl: './analytics-base-chart.component.html',
    styleUrl: './analytics-base-chart.component.css',
    standalone: false
})
export class AnalyticsBaseChartComponent {
  @Input() isLoading: boolean = false;
  @Input() hasData: boolean = true;
  @Input() showTitle: boolean = true;
  @Input() listData: any[] = [];
}
